import { Box } from '@mui/material'

type props = {
    onClick: () => void
}

const LogoBtnLink = ({onClick}: props) => {
  return (
    <>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, cursor:"pointer" }} role="button" onClick={onClick} >
            <img src={"/assets/wiKeyLogo1.png"} alt="logo" height={60} />
        </Box>
        <Box sx={{flexGrow: 1, display: {  xs: 'flex', md: 'none' }, mr: 1, cursor:"pointer" }} role="button" onClick={onClick} >
            <img src={"/assets/wiKeyLogo1.png"} alt="logo" height={60} />
        </Box>
    </>
  )
}

export default LogoBtnLink